const getters = {
  bannerDetails: state => state.bannerDetails,
  banners: state => state.banners,
  editableBannerFields: state => state.editableBannerFields,
  isBannersLoading: state => state.isBannersLoading,
}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/banner/banner.getters.js